module.exports = __webpack_public_path__ + "static/media/MountainPeakFlashbackA0007_design_clean_v002.9624f0e0.webp";